/* Marinelie — Kürzel in der Suche.
   Die Hausnamen sind lang, im Alltag heißt der Duft "BDV" oder "SSH".
   Shopifys Vorschlagssuche kennt nur Titel, Art, Hersteller und Varianten
   — Tags liest sie nicht. Deshalb wird das Kürzel hier übersetzt, bevor
   die Anfrage rausgeht: im Feld steht weiter, was getippt wurde, die
   Treffer kommen zum vollen Namen. Die Liste steht als Einstellung im
   Header (eine Zeile je Kürzel: KÜRZEL | Voller Name).
   Die Seite /search findet die Kürzel ohnehin — dort stehen sie als Tag
   am Produkt. */
(function () {
  'use strict';

  function karteLesen() {
    var feld = document.querySelector('[data-ml-kuerzel]');
    if (!feld) return null;
    var roh = '';
    try {
      roh = JSON.parse(feld.textContent) || '';
    } catch (err) {
      return null;
    }
    var karte = {};
    roh.split('\n').forEach(function (zeile) {
      var teile = zeile.split('|');
      if (teile.length < 2) return;
      var kurz = teile[0].trim().toLowerCase();
      var lang = teile.slice(1).join('|').trim();
      if (kurz && lang) karte[kurz] = lang;
    });
    return Object.keys(karte).length ? karte : null;
  }

  /* Wort für Wort: "bdv" wird zu "Besos de Vanilla", "bdv 2ml" zu
     "Besos de Vanilla 2ml". Was kein Kürzel ist, bleibt stehen. */
  function uebersetzen(begriff, karte) {
    return String(begriff)
      .split(/\s+/)
      .map(function (wort) {
        return karte[wort.toLowerCase()] || wort;
      })
      .join(' ');
  }

  customElements.whenDefined('predictive-search').then(function () {
    var Klasse = customElements.get('predictive-search');
    if (!Klasse || Klasse.prototype.mlKuerzel) return;
    var karte = karteLesen();
    if (!karte) return;

    var original = Klasse.prototype.getSearchResults;
    Klasse.prototype.getSearchResults = function (begriff) {
      return original.call(this, uebersetzen(begriff, karte));
    };
    Klasse.prototype.mlKuerzel = true;
  });
})();
